/**
 * Created by piotr.pozniak@thebeaverhead.com on 14/11/2024
 */

import React from "react";

export const LoaderIndicatorRow = () => (
  <div className={"events-list--row-wrapper rev--loader-events-list-item"}>
    <div className="events-list--row">
      <div className={"rev-preloader-block"}></div>
    </div>
  </div>
);

const LoaderIndicator = () => {
  return (
    <div className={"events-list-container "}>
      <LoaderIndicatorRow />
      <LoaderIndicatorRow />
      <LoaderIndicatorRow />
    </div>
  );
};

export default LoaderIndicator;
